/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".reports[_ngcontent-%COMP%]{margin:2em 0 0;list-style-type:none;padding:0}.reports[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{cursor:pointer;position:relative;left:0;background-color:#fff;margin:.2em;padding:.9em;border-radius:4px}.reports[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:hover{left:.1em}"];
export { styles as styles };
